// removed by extract-text-webpack-plugin
module.exports = {"root":"ReviewModal__root__3B9AR","modalContent":"ReviewModal__modalContent__gzVjY","modalIcon":"ReviewModal__modalIcon__1r0hN","modalTitle":"ReviewModal__modalTitle__qt34N","reviewee":"ReviewModal__reviewee__1GdIY","modalMessage":"ReviewModal__modalMessage__w8yo6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewModal/ReviewModal.css
// module id = 2075
// module chunks = 0